export default {
  metadata: {
    version: '1.0.0',
    id: 'fab-1.0.0',
    name: 'JDSFABInternal',
    description:
      'The Floating Action Button(FAB) performs the primary, or most common, action on a screen.',
    usage:
      'It places the key user action within easy reach by being persistently visible at a fixed point on a screen.'
  },
  hierarchy: {
    container: ['icon', 'jds-text']
  },
  base: {
    container: {
      hidden: false,
      'background-color': '{f_6}',
      display: 'flex',
      'flex-direction': '{f_7}',
      'justify-content': '{f_8}',
      'align-items': '{f_9}',
      gap: '{f_10}',
      'border-radius': '{f_11}',
      'padding-top': '{f_12}',
      'padding-left': '{f_13}',
      'padding-right': '{f_14}',
      'padding-bottom': '{f_15}',
      'border-color': '{f_16}',
      'border-width': '{f_17}',
      'enter-animation-name': 'slideVerticallyUp',
      'exit-animation-name': 'slideVerticallyDown',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      'translate-y': '0',
      transition: {
        property: [
          'background-color',
          'box-shadow',
          'padding-left',
          'padding-right',
          'translate-y'
        ],
        duration: '{rapid}',
        'timing-function': '{easeJoyfulEntrance}'
      },
      'box-shadow': {
        x: 0,
        y: 4,
        blur: 16,
        spread: 0,
        color: '#00000014'
      },
      behavior: {
        hover: {
          'background-color': '{f_18}',
          'box-shadow': {
            x: 0,
            y: 4,
            blur: 16,
            spread: 0,
            color: '#00000029'
          }
        },
        active: {
          'background-color': '{f_19}',
          'box-shadow': {
            x: 0,
            y: 4,
            blur: 16,
            spread: 0,
            color: '#0000003D'
          }
        },
        focus: {
          'background-color': '{f_20}',
          'border-width': '{f_21}',
          'box-shadow': {
            x: 0,
            y: 4,
            blur: 16,
            spread: 0,
            color: '#00000029'
          }
        }
      }
    },
    icon: {
      hidden: false,
      size: '{f_22}',
      color: '{f_23}',
      'border-radius': '{f_24}',
      behavior: {
        active: {
          color: '{f_25}'
        }
      }
    },
    'jds-text': {
      'font-family': '{text_137}',
      color: '{text_32}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false,
      behavior: {
        active: {
          color: '{text_30}'
        }
      }
    }
  },
  variant: {
    show: {
      false: {
        container: {
          hidden: true,
          'translate-y': '{size.max}'
        }
      }
    },
    extend: {
      false: {
        container: {
          'padding-left': '{f_26}',
          'padding-right': '{f_27}'
        },
        'jds-text': {
          hidden: true
        }
      }
    },
    _hasTitle: {
      false: {
        'jds-text': {
          hidden: true
        }
      }
    }
  },
  combination: [{}],
  combination_config: [],
  api: {
    data: {
      icon: {
        value: {
          type: 'icon',
          name: 'icon',
          doc_description: 'It displays icon of FAB.'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'title',
          doc_description: 'It displays the title of FAB.'
        }
      }
    },
    config: {
      show: {
        values: [true, false],
        doc_description: 'It can be used to show or hide FAB.'
      },
      extend: {
        values: [true, false],
        doc_description: 'When false, shows only icon.'
      },
      _hasTitle: {
        values: [true, false]
      }
    },
    events: {
      container: {
        onClick: 'onClick',
        onHover: {
          name: 'onHover',
          platform: 'web'
        },
        onHoverEnd: {
          name: 'onHoverEnd',
          platform: 'web'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'button'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'title'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
